import { jsx as _jsx } from "react/jsx-runtime";
import moment from "moment";
import { useMemo } from "react";
import { replaceMultiple } from "@/utils/funcs";
import { useAppSelector } from "@/hooks/store";
import { getCurrentUserDateFormat, getCurrentUserTimeFormat, } from "@/store/utils/selectors/userSelector";
export var defaultDateTimeFormat = "DD/MM/YYYY HH:mm";
/** <b>Composant en mode consultation/detail d'un champ de type Datetime</b>*/
export default function DateTimeFieldDetail(_a) {
    var fieldName = _a.fieldName, record = _a.record, fieldMetadata = _a.fieldMetadata, _b = _a.format, format = _b === void 0 ? defaultDateTimeFormat : _b;
    var dateFormat = useAppSelector(getCurrentUserDateFormat);
    var timeFormat = useAppSelector(getCurrentUserTimeFormat);
    var replacements = {
        m: "MM",
        d: "DD",
        Y: "YYYY",
        H: "HH",
        i: "mm",
        A: "A",
    };
    var dateTimeFormat = useMemo(function () {
        if (!dateFormat || !timeFormat) {
            return format;
        }
        return replaceMultiple("".concat(dateFormat, " ").concat(timeFormat), replacements);
    }, [dateFormat, timeFormat, format, replacements]);
    var value = useMemo(function () {
        if (!record) {
            return "";
        }
        return record[fieldName || ""] || "";
    }, [record]);
    var dateMomentObject = useMemo(function () {
        var candidateFormats = [
            dateTimeFormat,
            "YYYY-MM-DD HH:mm:ss",
            "YYYY-MM-DD HH:mm",
            moment.ISO_8601, // vrai ISO 8601 standard, au cas où
        ];
        return value === ""
            ? moment(new Date(), dateTimeFormat)
            : moment(value, candidateFormats, true);
    }, [value, dateTimeFormat]);
    var dateObject = dateMomentObject.toDate();
    return (_jsx("span", { children: dateObject ? dateMomentObject.format(dateTimeFormat) : value }));
}
